import { render, staticRenderFns } from "./TextToSpeechDemo.vue?vue&type=template&id=3e5e1799&scoped=true&"
import script from "./TextToSpeechDemo.vue?vue&type=script&lang=js&"
export * from "./TextToSpeechDemo.vue?vue&type=script&lang=js&"
import style0 from "./TextToSpeechDemo.vue?vue&type=style&index=0&id=3e5e1799&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5e1799",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VRadio,
  VRadioGroup,
  VSelect,
  VSlider,
  VSpacer,
  VTextarea,
  VTooltip,
})
